import { render, staticRenderFns } from "./pimpinantinggi.vue?vue&type=template&id=d056b2d2"
import script from "./pimpinantinggi.vue?vue&type=script&lang=js"
export * from "./pimpinantinggi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports